<template lang="pug">
  div.consume
    div
      p {{$t('goodsList')}}
        div(class="hst_box van-clearfix", v-for='(item, key) in orderList', v-if="item.status > -1", :key="key" @click="toChatPage(item)")
          p.title {{item.goodsName}}({{item.goodsCount}}{{$t('countNum')}})
          p.status(style="float: right;margin-top: 4px;") {{$t('priceLoading')}}{{item.successCount}}/{{item.totalCount}}
    p {{$t('orderID')}}{{item.orderId}}
    p {{$t('accountUID')}}{{item.uid}}
    p {{$t('totalAmount')}}{{item.currency !== 'POINT' ? (item.currency + "  " + item.totalMoney) : (item.totalMoney + "  " + $t('rebatePoint'))}}
    p {{$t('paymentChannel')}}{{item.orderType}}
    p(v-if="item.createTime") {{$t('orderCreationTime')}}{{formatDate(item.createTime)}}
    p(v-if="item.paySuccessTime") {{$t('orderPaymentTime')}}{{formatDate(item.paySuccessTime)}}
    p(v-if="item.notifyTime") {{$t('orderDeliveryTime')}}{{formatDate(item.notifyTime)}}
    p(v-if="item.serverName && item.serverName!=='0' && item.serverName !== ' '") {{$t('serverName')}}{{item.serverName}}
    p(v-if="item.roleName !== ' '") {{$t('roleName')}}{{item.roleName}}
    p(v-if="item.rebateCount && item.rebateCount !== '0'") {{$t('rebateGet', {msg: item.rebateCount})}}
    p(v-if="item.weekEndRebateCount && item.weekEndRebateCount !== '0'") {{$t('weekEndRebateCount', {msg: item.weekEndRebateCount})}}
    //- <div style="display: flex; justify-content: center">
    <van-button size="large" round type="danger" @click="toConsume">{{$t('return')}}</van-button>
    <van-button size="large" round type="danger" @click="toStore" style="margin-top: 20px;">{{$t('backToStore')}}</van-button>
    //- </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import qs from 'qs';
import moment from 'moment'

export default {
  name: 'Consume',
  data($vm){
    return{
        active: '',
        record: '',
        orderList:[],
        pageNumber: 1,
        listLoading: false,
        finished: false,
        loadStatus: true,
        item: '',
        accessToken: '',
        appId: '',
        language: '',
        storage: '',
        env: ''
    }
  },
  created(){
  },
  methods:{
    ...mapActions(['getThirdPayOrderList', 'orderSublist']),
    toStore(){
      this.$router.push({
        path: '/store'
      })
    },
    toConsume(){
      this.$router.push({
        path: '/consume'
      })
    },
    onListLoad(){
      if(this.loadStatus){
        return false
      }
      this.loadStatus = true
      this.pageNumber += 1
      // this.getThirdPayOrderList({
      //   accessToken: this.accessToken,
      //   pageNumber: this.pageNumber,
      //   language: this.language,
      //   appId: this.appId,
      // })
    }
  },
  computed:{
    ...mapGetters(['orderInfo', 'orderLoading', 'subList', 'subLoading']),
    status: $vm => {
      return [
        {
          text: $vm.$t('all'),
          value: ''
        },
        {
          text: $vm.$t('toBePaid'),
          value: '0'
        },
        {
          text: $vm.$t('tradeSuccess'),
          value: '100'
        }
      ]
    },
    formatDate: (val, key = false) => {
      return (val, key= false) => {
        if(key){
          return moment(parseInt(val)).format('YYYY-MM-DD HH:mm:ss') + '    ' + 'UTC+' + (0 - new Date().getTimezoneOffset() / 60)
        } else {
          return moment(parseInt(val)).format('YYYY-MM-DD HH:mm:ss')
        }
      }
    },
    formatStatus: $vm => {
      return val => {
        if(val === '0'){
          return $vm.$t('toBePaid')
        } else if(val === '100'){
          return $vm.$t('tradeSuccess')
        }
      }
    }
  },
  mounted(){
    this.env = CONFIG.env
    this.accessToken = window.localStorage.getItem('accessToken')
    this.appId = window.localStorage.getItem('appId')
    this.language = window.localStorage.getItem('language')
    this.storage = localStorage.getItem('storage') ? JSON.parse(localStorage.getItem('storage')) : []
    this.item = this.$route.query
    // this.$watch(() => window.i18n.locale, val => {
    //   this.getThirdPayOrderList({
    //     accessToken: this.accessToken,
    //     pageNumber: this.pageNumber,
    //     language: this.language,
    //     appId: this.appId,
    //     orderId: this.item.orderId,
    //     pageNumber: 1,
    //   })
    // })
    // if(this.env == 'cn'){
      this.orderSublist({
        masterOrderId: this.item.orderId,
        language: this.language,
        accessToken: this.accessToken,
      })
    // }
    this.$watch('subLoading', val => {
      if(val === 'loaded'){
        this.subList.map(val => {
          this.orderList.push(val)
        })
      }
    })
    this.$watch('orderLoading', val => {
      if(val === 'loaded'){
        this.orderInfo.list.map(val => {
          this.orderList.push(val)
        })
        // console.log(this.orderList)
        if(this.orderList.length == this.orderInfo.total){
          this.finished = true
        }
        this.loadStatus = false
        this.listLoading = false
      }
    })
    this.$watch('active', val => {
      this.pageNumber = 1
      this.loadStatus = true
      this.finished = false
      this.orderList = []
      // this.getThirdPayOrderList({
      //   accessToken: this.accessToken,
      //   pageNumber: this.pageNumber,
      //   language: this.language,
      //   appId: this.appId,
      //   pageNumber: 1,
      //   status: val
      // })
    })
  }
}
</script>
<style lang="scss">
.consume{
  margin: 20px;
  .van-button--large{
    width: calc(100% - 20px);
    height: 30px;
    font-size: 14px;
    border-radius: 15px;
  }
  img{
      width: 40%;
      margin: 0 auto;
      display: block;
  }
  // .van-button{
  //   height: 30px;
  //   margin: 0 auto;
  //   position: relative;
  //   display: block;
  //   line-height: 30px;
  //   text-align: center;
  //   width: 40%;
  // }
  .van-dropdown-menu__item{
    margin: 0 4px;
  }
  .van-dropdown-menu__title::after{
    right: 0px;
  }
  .select_box{
    width: 50%;
    position: relative;
    left: 50%;
    .van-dropdown-menu__bar{
      height: 30px;
    }
  }
  .consume_list{
    margin-top: 10px;
    .van-cell__value{
      position: absolute;
      right: 40px;
      line-height: 60px;
      p{
        margin: 0;
      }
    }
    .van-cell__right-icon{
      line-height: 60px;
    }
    .van-collapse-item__content{
      p{
        margin: 0;
        padding: 5px 10px;
      }
    }
  }
  .consume_icon{
    height: 60px;
    width: 60px;
    position: relative;
  }
  .title{
    margin: 0;
    font-size: 18px;
    color: #000;
    padding-left: 10px;
    font-weight: bolder;
  }
  .time{
    margin: 0;
    font-size: 12px;
    color: #969799;
    padding-left: 10px;
    margin-top: 12px;
  }
  .van-hairline--top-bottom::after{
    border-width: 0px;
  }
}
</style>